import { fromJS } from 'immutable';

export default fromJS({
    goodRecords: {}, badRecords: {},
});